<template>
  <v-container fluid>
    <ui-max-width width="md" align="center">
      <v-container class="pt-0 px-0">
        <ui-content>
          <h1>{{ $t('institution-edit-recruiters-educational-title') }}</h1>
        </ui-content>
      </v-container>
      <list-recruiters
        v-model="recruitersEducational"
        :companyId="institutionId"
        :removeFunction="removeRecruiterEducationalFromInstitution"
      />
      <v-form ref="form" lazy-validation>
        <form-multiple-recruiter
          :recruiterType="recruiterEducationalUserType"
          :showInitialRecruiterForm="false"
          v-model="addedRecruitersEducational"
          :currentRecruiters="recruitersEducational"
          :addedRecruiters="addedRecruitersEducational"
          @emailValidationCountChange="emailValidationCountChange"
          @emailValid="emailValid"
          @emailNotValid="emailNotValid"
        />
      </v-form>
    </ui-max-width>
    <ui-action>
      <v-btn
        :disabled="emailValidationCount > 0 || !isEmailValid"
        color="primary"
        round
        large
        @click="updateRecruitersEducational"
        >{{ $t('update-institution-recruiters-educational-btn') }}</v-btn
      >
    </ui-action>
  </v-container>
</template>

<script>
import Institution from '@/services/institution'
import NavCreateInstitution from '@/components/nav/nav-create-institution'
import FormMultipleRecruiter from '@/components/form/multiple-recruiter'
import ListRecruiters from '@/components/recruiters/list-recruiters'

import Notification from '@/services/notification'
import i18n from '@/helpers/i18n'

import { Consts } from '@/helpers/consts'

import gql from 'graphql-tag'

const GET_INSTITUTION_RECRUITERS_EDUCATIONAL_BY_ID = gql`
  query InstitutionById($institutionId: ID!) {
    institution(institutionId: $institutionId) {
      id
      name
      recruitersEducational {
        id
        isConfirmed
        email
        profile {
          id
          firstName
          lastName
        }
      }
    }
  }
`

export default {
  components: { NavCreateInstitution, FormMultipleRecruiter, ListRecruiters },
  data() {
    return {
      name: '',
      recruitersEducational: [],
      addedRecruitersEducational: [],
      emailValidationCount: 0,
      isEmailValid: true
    }
  },
  computed: {
    institutionId: function() {
      if (this.$route.params.institutionId !== undefined) {
        return this.$route.params.institutionId.split('-').last()
      }
      return null
    },
    recruiterEducationalUserType: function() {
      return Consts.USER_TYPE_RECRUITER_EDUCATIONAL
    },
    removeRecruiterEducationalFromInstitution: function() {
      return Institution.removeRecruiterEducationalFromInstitution
    }
  },
  methods: {
    updateRecruitersEducational: async function() {
      if (this.$refs.form.validate()) {
        await Institution.addRecruitersEducational(this.institutionId, this.addedRecruitersEducational)
        this.$apollo.queries.institution.refresh()
        this.addedRecruitersEducational = []
        Notification.showSuccess(i18n.instance().t('update-recruiters-educational-success-notification'), 6000)
      }
    },
    emailValidationCountChange: function(val) {
      this.emailValidationCount = val
    },
    emailValid: function() {
      this.isEmailValid = true
    },
    emailNotValid: function() {
      this.isEmailValid = false
    }
  },
  apollo: {
    institution: {
      query: GET_INSTITUTION_RECRUITERS_EDUCATIONAL_BY_ID,
      variables() {
        return {
          institutionId: this.institutionId
        }
      },
      result({ data, loading }) {
        if (data === undefined) {
          if (!loading) {
            //throw error
          }
          return
        }

        this.recruitersEducational = data.institution.recruitersEducational.map(x => {
          return {
            id: x.id,
            email: x.email,
            firstName: x.profile.firstName,
            lastName: x.profile.lastName,
            isConfirmed: x.isConfirmed
          }
        })
        this.name = data.institution.name
      },
      skip() {
        return this.institutionId === undefined || this.institutionId === null || this.institutionId === ''
      }
    }
  }
}
</script>
